import { render, staticRenderFns } from "./ExamRoomManagement.vue?vue&type=template&id=0cf509f6&scoped=true"
import script from "./ExamRoomManagement.vue?vue&type=script&lang=js"
export * from "./ExamRoomManagement.vue?vue&type=script&lang=js"
import style0 from "./ExamRoomManagement.vue?vue&type=style&index=0&id=0cf509f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf509f6",
  null
  
)

export default component.exports